import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  constructor() { }
  @ViewChild('gmap', {static: false}) gmapElement: ElementRef;
  map: google.maps.Map;

  ngOnInit(): void {

  }
  ngAfterViewInit():void{
    let mapProp = {
      center: new google.maps.LatLng(50.9327732, 5.338821),
      zoom: 16,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    let marker = new google.maps.Marker({
      position: new google.maps.LatLng(50.9335089, 5.3422147),
      map: this.map,
      icon: {url: '/assets/images/school-marker.png'}
    });
    this.map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);
    marker.setMap(this.map);
  }

}
